module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("5Yd1A"))).then(() => parcelRequire('d0iPb'));